import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotificationContainer from 'react-notifications-component';

import ProtectedRoute from './ProtectedRoute';
import Page404 from '../pages/Page404/Page404';
import routerProps, { sideBarPaths } from '../_helpers/routerProps';
import Header from '../components/Header/Header';
import { Content } from '../components/ThemeProvider/ThemeStyle';
import Footer from '../components/Footer/Footer';
import SideBar from '../components/Header/SideBar/SideBar';
import {
  checkLogin,
  loginModule,
  setIntegrationLoading,
  setIntegrationStatus,
  zagsAutoFill
} from '../pages/LoginPage/LoginDucks';
import paths from '../_helpers/paths';
import { history } from '../_helpers/history';
import TokenRefresher from '../components/TokenRefresher/TokenRefresher';
import Login from '../pages/LoginPage/Login';
import { getContentWidth } from '../utils/getContentWidth';
import HeadTitle from '../components/Head/HeadTitle';
import useSimpleModal from '../components/_hooks/useSimpleModal';
import IntegrationModal from '../pages/Home/Dialogs/IntegrationModal';

function Root({
  checkLogin,
  loadingIntegration,
  kdpGbdflStatus,
  zagsAutoFill,
  requester,
  ...props
}) {
  let [isCurrent, setIsCurrent] = React.useState(false);
  const integrationModal = useSimpleModal();
  const authKdpGbdflStatus = localStorage.getItem('authKdpGbdflStatus');
  const [showHelperText, setShowHelperText] = useState(false);
  const pollingTimeoutRef = useRef(null);
  const dontShowModal =
    requester &&
    (!requester['user_email'] || !requester['user_telephone_number']) &&
    authKdpGbdflStatus !== 'VALID';

  useEffect(() => {
    if (requester && props.location.pathname !== paths.accountSettingsPage) {
      if (dontShowModal) {
        integrationModal.open({});
      } else if (
        (!requester?.user_email || !requester?.user_telephone_number) &&
        authKdpGbdflStatus === 'VALID'
      ) {
        history.push(paths.accountSettingsPage);
      }
    }
  }, [requester, props.location.pathname, authKdpGbdflStatus]);

  useEffect(() => {
    checkLogin();
  }, [checkLogin]);

  const handleZagsPolling = () => {
    zagsAutoFill({
      close: integrationModal.close,
      onStatus: status => {
        if (status === 'PENDING') {
          pollingTimeoutRef.current = setTimeout(() => {
            if (integrationModal.isOpen) {
              handleZagsPolling();
            }
          }, 10000);
        }
      }
    });
  };
  const onZagsAutoFill = () => {
    setShowHelperText(false);
    handleZagsPolling();
  };
  const clearResources = () => {
    clearTimeout(pollingTimeoutRef.current);
    pollingTimeoutRef.current = null;
    setIntegrationStatus(null);
    setIntegrationLoading(false);
  };
  useEffect(() => {
    if (!integrationModal.isOpen && pollingTimeoutRef.current) {
      setShowHelperText(false);
      clearResources();
    }
  }, [integrationModal.isOpen]);

  React.useEffect(() => {
    const isMatch =
      props.location.pathname === paths.kindergartenServices ||
      props.location.pathname === paths.homePage;
    setIsCurrent(isMatch);
  }, [props.location.pathname]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [props.location.pathname]);

  const contentWidth = getContentWidth(props.location.pathname);

  const onDonIntegration = () => {
    setShowHelperText(true);
    clearTimeout(pollingTimeoutRef.current);
    pollingTimeoutRef.current = null;
    setIntegrationStatus(null);
    setIntegrationLoading(false);
  };
  return (
    <>
      <NotificationContainer className="left-0 top-0" />
      {props.user && <TokenRefresher />}
      <Login integrationModal={integrationModal} />
      {integrationModal.isOpen && (
        <IntegrationModal
          title="accountSettingsPage_autoFillIntegration"
          {...integrationModal}
          onDonIntegration={onDonIntegration}
          onZagsInit={() => onZagsAutoFill()}
          loadingIntegration={loadingIntegration}
          helperText={showHelperText}
          kdpGbdflStatus={kdpGbdflStatus}
          clearResources={clearResources}
          setShowHelperText={setShowHelperText}
        />
      )}
      <HeadTitle />
      <Header contentWidth={contentWidth} isCurrent={isCurrent} />
      <Switch>
        <Content
          contentWidth={contentWidth}
          className={isCurrent && 'kindergartenServices'}
        >
          <Route exact path={sideBarPaths} component={SideBar} />
          <ProtectedRoute exact {...props} {...routerProps.homePage} />
          <ProtectedRoute exact {...props} {...routerProps.marketAndroidPage} />
          <ProtectedRoute exact {...props} {...routerProps.kindergartenServices} />
          <ProtectedRoute exact {...props} {...routerProps.govServices} />
          <ProtectedRoute exact {...props} {...routerProps.checkQueueNumber} />
          <Route exact {...props} {...routerProps.queueApplications} />
          <Route exact {...props} {...routerProps.bulletinOpenPlaces} />
          <ProtectedRoute exact {...props} {...routerProps.bulletinOpenPlacesKqId} />
          <ProtectedRoute exact {...props} {...routerProps.bulletinOpenPlacesVoucher} />
          <Route exact {...props} {...routerProps.kindergartenReestr} />
          <ProtectedRoute
            exact
            {...props}
            {...routerProps.kindergartenReestrByKindergantenId}
          />
          <ProtectedRoute
            exact
            {...props}
            {...routerProps.kindergartenReestrByVoucherId}
          />
          <ProtectedRoute
            exact
            {...props}
            {...routerProps.kindergartenReestrByVoucherIdAndChangeDuo}
          />
          <ProtectedRoute exact {...props} {...routerProps.createRequestPage} />
          <ProtectedRoute exact {...props} {...routerProps.accountPage} />
          <ProtectedRoute exact {...props} {...routerProps.requestsPage} />
          <ProtectedRoute exact {...props} {...routerProps.completedRequestsPage} />
          <ProtectedRoute exact {...props} {...routerProps.accountSettingsPage} />
          <ProtectedRoute exact {...props} {...routerProps.attachChildWithParentPage} />
          <ProtectedRoute exact {...props} {...routerProps.viewRequestFormPage} />
          <ProtectedRoute exact {...props} {...routerProps.instructionsPage} />
          <ProtectedRoute exact {...props} {...routerProps.videoInstructionsPage} />
          <ProtectedRoute exact {...props} {...routerProps.faqPage} />
          <ProtectedRoute exact {...props} {...routerProps.kindergartenApplications} />
          <ProtectedRoute exact {...props} {...routerProps.kindergartenAppointments} />
          <ProtectedRoute exact {...props} {...routerProps.kindergartenNotifications} />
          <ProtectedRoute exact {...props} {...routerProps.kindergartenAccompaniments} />
          <ProtectedRoute exact {...props} {...routerProps.voucherApplications} />
          <ProtectedRoute exact {...props} {...routerProps.voucherAppointments} />
          <ProtectedRoute exact {...props} {...routerProps.voucherWaitingList} />
        </Content>
        <Route component={Page404} />
      </Switch>
      <Footer contentWidth={contentWidth} />
    </>
  );
}

export default connect(
  state => ({
    user: state[loginModule].user,
    requester: state[loginModule].requester,
    userPermissions: state[loginModule].permissions,
    loading: state[loginModule].loading,
    loadingIntegration: state[loginModule].loadingIntegration,
    kdpGbdflStatus: state[loginModule].kdpGbdflStatus
  }),
  { checkLogin, setIntegrationStatus, setIntegrationLoading, zagsAutoFill }
)(withRouter(Root));
